import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Have you noticed a decrease in your sexual desire or interest?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_decreaseInSexualDesire',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Do you feel you have reduced sexual receptivity or fewer sexual thoughts than before?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_reducedSexualReceptivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label: 'Have you ever tried testosterone therapy before?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_triedTestosteroneTherapy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label: 'If so, did you find it helpful?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_foundTherapyHelpful',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' },
        { key: 'na', value: 'n/a' }
      ]
    }
  },
  {
    label:
      'Do you currently have, or are you being monitored for any estrogen- or androgen-sensitive cancer?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_estrogenAndrogenSensitiveCancer',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, trying to become pregnant, or breastfeeding?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_pregnantTryingPregnantBreastfeeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you ever been diagnosed with active liver disease (such as cirrhosis or hepatitis)?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_activeLiverDisease',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you ever been diagnosed with a severe psychiatric condition (such as psychosis or uncontrolled bipolar disorder)?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_severePsychiatricCondition',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you ever been diagnosed with uncontrolled hypertension, heart disease, or significant cardiovascular events?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_cardiovascularEvents',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you recently had psychiatric hospitalizations or episodes of instability?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_psychiatricHospitalizations',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Do you currently struggle with alcohol, opioid, stimulant, or other substance use?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_substanceUse',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you ever been diagnosed with PCOS (polycystic ovary syndrome) or elevated androgen levels?',
    educationalSlide: 'Please select one',
    field: 'testosteroneIntake_pcosElevatedAndrogen',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    }
  }
];

export default questionsModels;
